import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global CSS reset + spinner animation
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; }
  body { margin: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
  @keyframes spin { to { transform: rotate(360deg); } }
  a:hover { opacity: 0.85; }
  button:hover:not(:disabled) { opacity: 0.9; }
  select, input, textarea { font-family: inherit; }
  .loading-screen { display: flex; align-items: center; justify-content: center; min-height: 100vh; font-size: 16px; color: #888; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
